import React from 'react';
import { observer } from 'mobx-react';

import { PasswordConfirmationStore } from '../../stores/PasswordConfirmationStore';
import { BasicInput } from '../basic-input';
import { SecondaryButton } from '../secondary-button';
import { SimpleButton } from '../simple-button';
import { Modal } from '../modal';
import styles from './PasswordConfirmationModal.css';

class PasswordConfirmationModal extends React.Component {
  static onCancel(event) {
    event.preventDefault();
    PasswordConfirmationStore.cancelConfirmation();
  }

  constructor(props) {
    super(props);
    this.state = {
      password: null,
    };

    this._updatePassword = this._updatePassword.bind(this);
    this._confirmPassword = this._confirmPassword.bind(this);
  }

  _updatePassword(event) {
    this.setState({
      password: event.target.value,
    });
  }

  _confirmPassword(event) {
    event.preventDefault();
    if (this.state.password) {
      PasswordConfirmationStore.confirmPassword(this.state.password);
    }
  }

  render() {
    if (!PasswordConfirmationStore.modalEnabled) {
      return null;
    }

    let passwordError = null;
    if (this.state.password === '') {
      passwordError = 'El campo no puede ser vacío';
    }
    if (PasswordConfirmationStore.confirmationError) {
      passwordError = 'Estamos experimentando problemas, intente nuevamente por favor';
    } else if (PasswordConfirmationStore.passwordIncorrect) {
      passwordError = 'La contraseña es incorrecta.';
    }
    return (
      <Modal>
        <form className={styles.container} onSubmit={this._confirmPassword}>
          <h2 className={styles.title}>
            Antes de continuar, debe confirmar su contraseña.
          </h2>
          <BasicInput
            name="password"
            label="Contraseña"
            type="password"
            error={passwordError}
            onChange={this._updatePassword}
          />
          <div className={styles.buttonContainer}>
            <SecondaryButton
              className={styles.button}
              disabled={!this.state.password || PasswordConfirmationStore.loadingConfirmation}
            >
              Confirmar
            </SecondaryButton>
            <SimpleButton
              className={styles.button}
              onClick={PasswordConfirmationModal.onCancel}
            >
              Cancelar
            </SimpleButton>
          </div>
        </form>
      </Modal>
    );
  }
}

const ObservedPasswordConfirmationModal = observer(PasswordConfirmationModal);

export { ObservedPasswordConfirmationModal as PasswordConfirmationModal };



// WEBPACK FOOTER //
// ./src/common/password-confirmation-modal/PasswordConfirmationModal.jsx